var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0347 2.22568H13.4205V0.575684C13.4205 0.475647 13.3647 0.387816 13.297 0.328551C13.2284 0.268475 13.1343 0.225684 13.0347 0.225684H12.4633C12.2339 0.225684 12.0776 0.391122 12.0776 0.575684V2.22568H5.42045V0.575684C5.42045 0.475647 5.36475 0.387816 5.29702 0.328551C5.22836 0.268475 5.13426 0.225684 5.03474 0.225684H4.46331C4.23394 0.225684 4.0776 0.391122 4.0776 0.575684V2.22568H2.46331C1.45533 2.22568 0.649023 2.94709 0.649023 3.82568V14.8257C0.649023 15.7368 1.45676 16.4257 2.46331 16.4257H15.0347C16.0041 16.4257 16.849 15.738 16.849 14.8257V3.82568C16.849 2.94583 16.0056 2.22568 15.0347 2.22568ZM15.5062 14.8257C15.5062 14.9307 15.4529 15.0294 15.3633 15.1045C15.2734 15.1799 15.1531 15.2257 15.0347 15.2257H2.46331C2.18415 15.2257 1.99188 15.0396 1.99188 14.8257V6.42568H15.5062V14.8257ZM15.5062 5.22568H1.99188V3.82568C1.99188 3.63928 2.18835 3.42568 2.46331 3.42568H15.0347C15.1495 3.42568 15.2697 3.47664 15.3617 3.55719C15.4547 3.63855 15.5062 3.73822 15.5062 3.82568V5.22568Z",
    fill: "#9CAAB4",
    stroke: "#9CAAB4",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7494 7.61401L9.46469 9.81544H11.7794L9.90676 11.176L10.622 13.3774L8.7494 12.0169L6.87676 13.3774L7.59205 11.176L5.71941 9.81544H8.03412L8.7494 7.61401Z",
    fill: "#9CAAB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseDate);
export default __webpack_public_path__ + "static/media/release-date.9592923eebb07ec3b60dea27dc6af4c8.svg";
export { ForwardRef as ReactComponent };